import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { router } from '@/router';
import { initObservability, Sentry } from '@/observability';
import '@/styles/main.scss';

initObservability();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

function FallbackError() {
  return (
    <main style={{ padding: 32, fontFamily: 'Inter, sans-serif' }}>
      <h1>Algo ha fallado</h1>
      <p>Recarga la página o avisa al equipo.</p>
    </main>
  );
}

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackError />}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
